import React from "react";
import { useNavigate } from "react-router-dom";
import { AlertCircle, Home, ArrowLeft } from "lucide-react";

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8 font-poppins">
            <div className="max-w-md w-full text-center space-y-8">
                {/* Visual Icon */}
                <div className="flex justify-center">
                    <div className="bg-indigo-100 p-6 rounded-full">
                        <AlertCircle className="w-16 h-16 text-indigo-600" />
                    </div>
                </div>

                {/* Text Content */}
                <div className="space-y-4">
                    <h1 className="text-6xl font-extrabold text-gray-900 tracking-tight">404</h1>
                    <h2 className="text-2xl font-bold text-gray-800">QR Code Not Found</h2>
                    <p className="text-gray-500 text-sm leading-relaxed">
                        The QR code you scanned doesn't seem to exist or has been deactivated. 
                        Please contact the property administrator or check the link again.
                    </p>
                </div>

                {/* Actions */}
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
                    <button
                        onClick={() => navigate(-1)}
                        className="w-full sm:w-auto flex items-center justify-center px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 transition-all shadow-sm"
                    >
                        <ArrowLeft className="w-4 h-4 mr-2" />
                        Go Back
                    </button>
                    <button
                        onClick={() => window.location.href = "https://review.onelyk.com"}
                        className="w-full sm:w-auto flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 transition-all shadow-sm"
                    >
                        <Home className="w-4 h-4 mr-2" />
                        Visit OneLyk
                    </button>
                </div>

                {/* Footer Branding */}
                <div className="pt-12">
                    <img 
                        src="/logo.png" 
                        alt="OneLyk Logo" 
                        className="h-8 mx-auto opacity-50 grayscale"
                        onError={(e) => e.target.style.display = 'none'}
                    />
                    <p className="mt-2 text-xs text-gray-400">Powered by OneLyk Ecosystem</p>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
